import React from 'react';
import { makeStyles, Theme } from '@material-ui/core';
import MaintenanceImg from '../../images/Maintenance.jpg';
import DisasterImg from '../../images/Disaster.jpg';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    backgroundColor: '#023c61',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '60% auto',
    backgroundPosition: 'center',
    [`${theme.breakpoints.down('md')} and (orientation: portrait)`]: {
      backgroundSize: '80% auto',
      fontSize: '10px',
    },
    [`${theme.breakpoints.down('sm')} and (orientation: portrait)`]: {
      backgroundSize: '80% auto',
      fontSize: '10px',
    },
    [`${theme.breakpoints.down('sm')} and (orientation: landscape)`]: {
      backgroundSize: 'auto 90%',
      fontSize: '10px',
    },
  },
  button: {
    position: 'absolute',
  },
}));
interface MaintenancePageProps {
  flag: string;
}
export default function MaintenancePage({ flag }: MaintenancePageProps) {
  const classes = useStyles();
  return (
    <div>
      {flag === 'maintenance' ? (
        <div className={classes.container} style={{ backgroundImage: `url(${MaintenanceImg})` }}>
          <a className={classes.button} href="tel:1800123633">
            1800 123 633
          </a>
        </div>
      ) : (
        <div className={classes.container} style={{ backgroundImage: `url(${DisasterImg})` }}>
          <a className={classes.button} href="tel:1800123633">
            1800 123 633
          </a>
        </div>
      )}
    </div>
  );
}
